import {
	ADD_PROFORMA_SUCCESS,
	APPROVE_PROFORMA_SUCCESS,
	CLEAN_REDUCER,
	CLEAR_SESSION,
	DENY_PROFORMA_SUCCESS,
	FETCH_PROFORMA_COUNT,
	GET_PROFORMA,
	GET_PROFORMAS,
	PROFORMA_INVOICED_SUCCESS,
	SET_PROFORMA_TO_ADD,
	STATUS_FILTER,
	UPDATE_PAGE,
	UPDATE_SEARCH,
} from './actionTypes';

const initState = {
	proformas: [],
	proforma: {},
	statusFilter: 5,
	count: 0,
	search: '',
	page: 1,
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case UPDATE_SEARCH:
			return {
				...state,
				search: action.search,
			};
		case UPDATE_PAGE:
			return {
				...state,
				page: action.page,
			};
		case GET_PROFORMAS:
			return {
				...state,
				proformas: action.proformas,
			};
		case FETCH_PROFORMA_COUNT:
			return {
				...state,
				count: action.count,
			};
		case ADD_PROFORMA_SUCCESS:
			return {
				...state,
				proforma: action.proforma,
			};
		case STATUS_FILTER:
			return {
				...state,
				statusFilter: action.statusFilter,
			};
		case GET_PROFORMA:
			return {
				...state,
				proforma: action.proforma,
			};
		case SET_PROFORMA_TO_ADD:
			return {
				...state,
				proforma: action.proforma,
			};
		case DENY_PROFORMA_SUCCESS:
			return state;
		case APPROVE_PROFORMA_SUCCESS:
			return state;
		case PROFORMA_INVOICED_SUCCESS:
			return state;
		case CLEAN_REDUCER:
			return initState;
		case CLEAR_SESSION:
			return initState;
		default:
			return state;
	}
};

export default reducer;
